// src/pages/Header.js
import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom"; // 1. Import useNavigate
import { useTranslation } from "react-i18next";

const Header = () => {
  const { t, i18n } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate(); // 2. Initialize the navigate function

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === "en" ? "es" : "en");
  };

  // 3. Create a new function to handle navigation with a delay
  const handleNavigate = (path) => {
    // First, start closing the menu immediately
    setIsMenuOpen(false);

    // Then, wait for the closing animation to start before changing the page
    setTimeout(() => {
      navigate(path);
    }, 300); // 300ms is a good delay for a smooth transition
  };

  return (
    <header className="reusable-page-header">
      <div className="band-name">
        <NavLink to="/">{t("bandName")}</NavLink>
      </div>

      <nav className={`page-nav ${isMenuOpen ? "menu-open" : ""}`}>
        <ul>
          {/* 4. Update the links to use the new handleNavigate function */}
          <li>
            <button onClick={() => handleNavigate("/music")}>
              {t("navMusic")}
            </button>
          </li>
          <li>
            <button onClick={() => handleNavigate("/contact")}>
              {t("navContact")}
            </button>
          </li>
          <li>
            <button onClick={() => handleNavigate("/booking")}>
              {t("navBookMe")}
            </button>
          </li>
          <li>
            <button onClick={toggleLanguage} className="lang-switch">
              {i18n.language === "en" ? "Español" : "English"}
            </button>
          </li>
        </ul>
      </nav>

      <button
        className={`hamburger-menu ${isMenuOpen ? "active" : ""}`}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </button>
    </header>
  );
};

export default Header;
